import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

export default class DocumentTitleCell extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    return (
      <td {...this.props.tdProps}><Link to={`/document/${this.props.dataItem.DocumentID}`}>{this.props.dataItem.Title || "No Title"}</Link></td>
    );
  }
}

export class DocumentCreatedCell extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    return (
      <td {...this.props.tdProps}><span>{dayjs.utc(this.props.dataItem.CreatedDate).local().format('MM/DD/YYYY hh:mm a')}</span></td>
    );
  }
}
